import styled from 'styled-components';

export const ChatListContainer = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: white;
`;

export const ChatListContent = styled.div`
	overflow: auto;
	min-width: 220px;
`;

export const ChatListHeader = styled.div`
	padding: 9px 15px;
	color: white;
	cursor: pointer;
	line-height: 30px;
	background-color: ${props => props.backgroundColor};
`;

export const Container = styled.div`
	display: flex;
	flex: 1;
	flex-direction: row;
	align-items: flex-end;
	height: 0;
`;

export const WrapperContainer = styled.div`
	position: absolute;
	z-index: 1;
	bottom: 0;
	right: 100px;
`;